module.exports = __webpack_public_path__ + "static/img/Box4.ed89f5a.png";


//////////////////
// WEBPACK FOOTER
// ./static/Activity/2018HuaTie/MidPic/Box4.png
// module id = 870
// module chunks = 18